import { createReduxModule } from "hooks-for-redux";

const defaultAssistantsState = [];

export const [useAssistants, { setAssistants, setAssistant }] = createReduxModule(
  "assistants",
  defaultAssistantsState,
  {
    setAssistants: (state, data) => {
      if (!data) return state;
      return [...data];
    },
    setAssistant: (state, data) => {
      if (!data) return state;
      return state.map((s) => (s.assistant_id === data.assistant_id ? data : s));
    },
  }
);
